module.exports = __webpack_public_path__ + "img/img_judges3.5658dbda.png";